import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { Button } from './ui/Button';
import { useTheme } from '../hooks/useTheme';

export const ThemeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      aria-label={`Cambiar a tema ${isDarkMode ? 'claro' : 'oscuro'}`}
      title={`Cambiar a tema ${isDarkMode ? 'claro' : 'oscuro'}`}
    >
      {isDarkMode ? <Sun size={20} /> : <Moon size={20} />}
    </Button>
  );
};
